import {Component, Input, OnInit} from '@angular/core';
import {Wiadomosc} from '../../../classess/widomosc';

@Component({
  selector: 'app-wiadomosc',
  templateUrl: './wiadomosc.component.html',
  styleUrls: ['./wiadomosc.component.css']
})
export class WiadomoscComponent implements OnInit {

  @Input()
  wiadomosc: Wiadomosc;

  constructor() { }

  ngOnInit(): void {
  }

}
